import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { tareasService } from '../services/tareas.service';
import { useAuthStore } from '../store/useAuthStore';
import { useWorkspaceStore } from '../store/useWorkspaceStore';

export const useTareasQuery = () => {
  const { token } = useAuthStore();
  const { activeWorkspaceId } = useWorkspaceStore();
  
  return useQuery({
    queryKey: ['tareas', activeWorkspaceId],
    queryFn: tareasService.getTareas,
    enabled: !!token && activeWorkspaceId !== 'default',
    initialData: [],
  });
};

export const useCrearTareaMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: tareasService.crearTarea,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tareas'] });
    },
  });
};

export const useActualizarTareaMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: tareasService.actualizarTarea,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tareas'] });
    },
  });
};

export const useEliminarTareaMutation = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: tareasService.eliminarTarea,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['tareas'] });
    },
  });
};
